/**
 * @generated SignedSource<<6a4df8b4705b40c165b2f048d31c0f05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WebhookSubscriptionType = "DATADOG" | "FIREHYDRANT" | "INCIDENT_IO" | "OPSGENIE" | "PAGERDUTY" | "ROOTLY" | "SLACK" | "%future added value";
export type CreateOrUpdateWebhookSubscriptionInput = {
  webhookConfigs: ReadonlyArray<WebhookSubscriptionConfigInput>;
  webhookSubscriptionType: WebhookSubscriptionType;
};
export type WebhookSubscriptionConfigInput = {
  id?: any | null | undefined;
  name: string;
  opsgenieApiKey?: string | null | undefined;
  remoteId: string;
  secret: string;
};
export type FireHydrantIntegrationCreateOrUpdateWebhookSubscriptionMutation$variables = {
  input: CreateOrUpdateWebhookSubscriptionInput;
};
export type FireHydrantIntegrationCreateOrUpdateWebhookSubscriptionMutation$data = {
  readonly createOrUpdateWebhookSubscription: {
    readonly error: string | null | undefined;
    readonly webhookSubscriptions: ReadonlyArray<{
      readonly id: any;
      readonly name: string;
      readonly remoteId: string;
    }> | null | undefined;
  };
};
export type FireHydrantIntegrationCreateOrUpdateWebhookSubscriptionMutation = {
  response: FireHydrantIntegrationCreateOrUpdateWebhookSubscriptionMutation$data;
  variables: FireHydrantIntegrationCreateOrUpdateWebhookSubscriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOrUpdateWebhookSubscriptionPayload",
    "kind": "LinkedField",
    "name": "createOrUpdateWebhookSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLWebhookSubscription",
        "kind": "LinkedField",
        "name": "webhookSubscriptions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remoteId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FireHydrantIntegrationCreateOrUpdateWebhookSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FireHydrantIntegrationCreateOrUpdateWebhookSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "21b7f3af216f79d21d42e6905764a419",
    "id": null,
    "metadata": {},
    "name": "FireHydrantIntegrationCreateOrUpdateWebhookSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation FireHydrantIntegrationCreateOrUpdateWebhookSubscriptionMutation(\n  $input: CreateOrUpdateWebhookSubscriptionInput!\n) {\n  createOrUpdateWebhookSubscription(input: $input) {\n    webhookSubscriptions {\n      id\n      name\n      remoteId\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ef7b7d45a7d0462ecd4b5db6f01362d";

export default node;
